"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var PresentationWindow_1 = __importDefault(require("./PresentationWindow"));
var WindowUnresponsiveError_1 = __importDefault(require("./WindowUnresponsiveError"));
var WindowTimeoutError_1 = __importDefault(require("./WindowTimeoutError"));
var WindowLoadError_1 = __importDefault(require("./WindowLoadError"));
// Wait at least 3 seconds before restarting or moving onto the next window
// to prevent log spam causing devices to become unresponsive.
var minTimeBetweenCompletes = 3000;
var PlaylistWindowManager = /** @class */ (function (_super) {
    __extends(PlaylistWindowManager, _super);
    function PlaylistWindowManager(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.currentPresentation = null;
        _this.nextPresentation = null;
        _this.overrideNextPresentation = null;
        _this.currentWindow = null;
        _this.nextWindow = null;
        _this.hasPendingInterrupt = false;
        _this.ruleEngine = null;
        _this.state = null;
        _this.renderer = null;
        _this.restartCurrentWindowOnEnd = false;
        _this.shouldHardRestart = false;
        _this.currentWindowError = null;
        _this.interruptCheckTimeout = null;
        _this.currentPresentationCompleteTimeout = null;
        _this.lastCompleteAt = null;
        _this.forceMute = false;
        _this.isFocused = false;
        _this.workerState = {};
        _this.handleEnableInterruptLock = function () {
            var onEnableInterruptLock = _this.options.onEnableInterruptLock;
            if (onEnableInterruptLock) {
                onEnableInterruptLock();
            }
        };
        _this.handleDisableInterruptLock = function () {
            var onDisableInterruptLock = _this.options.onDisableInterruptLock;
            if (onDisableInterruptLock) {
                onDisableInterruptLock();
            }
            if (_this.hasPendingInterrupt) {
                _this.endCurrentPresentation();
            }
        };
        _this.handleAnalyticsEvent = function (event) {
            // Emit the event on the current window. Only the current window should
            // send analytics events since the next window is not visible.
            _this.emitCurrentWindowEvent('window_analytics_event', event);
        };
        _this.handleChargeRequest = function (request) {
            // Emit the event on the current window. Only the current window should
            // send charge requests since the next window is not visible.
            _this.emitCurrentWindowEvent('window_charge_request', request);
        };
        _this.handleCurrentPresentationComplete = function () { return __awaiter(_this, void 0, void 0, function () {
            var logger, isThrottled, now, timeSinceLastComplete, delay, _a, next, preview, nextPreviewPresentationId;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger = this.options.logger;
                        isThrottled = false;
                        if (this.lastCompleteAt !== null) {
                            now = new Date();
                            timeSinceLastComplete = +now - +this.lastCompleteAt;
                            if (timeSinceLastComplete < minTimeBetweenCompletes) {
                                isThrottled = true;
                                // Throttle presentation complete handler if we have not throttled already.
                                if (this.currentPresentationCompleteTimeout === null) {
                                    delay = minTimeBetweenCompletes - timeSinceLastComplete + 1;
                                    logger.warn("Throttling presentation complete handler for ".concat(delay, "ms because it was called again in less than ").concat(minTimeBetweenCompletes, "ms"));
                                    this.currentPresentationCompleteTimeout = setTimeout(function () {
                                        _this.currentPresentationCompleteTimeout = null;
                                        _this.handleCurrentPresentationComplete();
                                    }, delay);
                                }
                                else {
                                    logger.warn("Skipping presentation complete because it is currently throttled");
                                }
                            }
                        }
                        // Don't run presentation complete handler when throttled.
                        if (isThrottled) {
                            return [2 /*return*/];
                        }
                        // Not throttled, update lastCompleteAt and run presentation complete handler.
                        this.lastCompleteAt = new Date();
                        // Emit presentation end events.
                        if (this.currentWindowError) {
                            this.emitCurrentWindowErrorEvent('window_end_error', this.currentWindowError);
                        }
                        else {
                            this.emitCurrentWindowEvent('window_end_success');
                        }
                        // Clear current window error flag.
                        this.currentWindowError = null;
                        if (!(!this.isLocked() &&
                            !this.restartCurrentWindowOnEnd &&
                            this.currentWindow &&
                            this.nextWindow)) return [3 /*break*/, 5];
                        if (!this.nextWindow.isReady()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.swapWindows()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: 
                    // The next window isn't ready yet, restart the current presentation.
                    // restartCurrentWindow depends on this.shouldHardRestart
                    return [4 /*yield*/, this.restartCurrentWindow()];
                    case 3:
                        // The next window isn't ready yet, restart the current presentation.
                        // restartCurrentWindow depends on this.shouldHardRestart
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 12];
                    case 5:
                        if (!this.currentWindow) return [3 /*break*/, 9];
                        _a = this.evalRuleEngine(), next = _a.next, preview = _a.preview;
                        nextPreviewPresentationId = preview.presentationId;
                        if (!!next.presentationId) return [3 /*break*/, 6];
                        // If next.presentationId is null after evaluating the rule engine that means
                        // nothing should be playing, remove the current window.
                        this.removeCurrentWindow();
                        return [3 /*break*/, 8];
                    case 6: 
                    // Restart the current presentation when:
                    // - There's only one presentation in the playlist (no preload)
                    // - The playlist is locked or paused
                    // - There is a still a presentation that should be
                    // NOTE: restartCurrentWindow depends on this.shouldHardRestart
                    return [4 /*yield*/, this.restartCurrentWindow()];
                    case 7:
                        // Restart the current presentation when:
                        // - There's only one presentation in the playlist (no preload)
                        // - The playlist is locked or paused
                        // - There is a still a presentation that should be
                        // NOTE: restartCurrentWindow depends on this.shouldHardRestart
                        _b.sent();
                        // Check to see if there is a presentation to preload. This can happen if
                        // if state has changed since initial load (ie. publish).
                        if (this.shouldPreload(nextPreviewPresentationId)) {
                            this.nextPresentation = preview;
                            this.preloadNextWindow();
                        }
                        _b.label = 8;
                    case 8: return [3 /*break*/, 12];
                    case 9:
                        if (!this.nextWindow) return [3 /*break*/, 11];
                        // There is no current window but there is a next window. Swap to the next window.
                        // This can happen if updating the rule engine from an empty playlist to a non-empty playlist.
                        return [4 /*yield*/, this.swapWindows()];
                    case 10:
                        // There is no current window but there is a next window. Swap to the next window.
                        // This can happen if updating the rule engine from an empty playlist to a non-empty playlist.
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        logger.warn("Presentation complete received but there's no current window.");
                        _b.label = 12;
                    case 12:
                        // Clear hard restart after running complete handler. This could be true when the current window errors
                        // but if there's another presentation to move on to we won't restart it but we still need to clear it
                        // so we don't hard restart the new current window when we shouldn't.
                        this.shouldHardRestart = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleCurrentPresentationError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var logger, isWindowError;
            return __generator(this, function (_a) {
                logger = this.options.logger;
                logger.warn("Current presentation had an error, move to next presentation or hard restart current window");
                isWindowError = error instanceof WindowUnresponsiveError_1.default ||
                    error instanceof WindowTimeoutError_1.default ||
                    error instanceof WindowLoadError_1.default;
                if (isWindowError) {
                    // Error is window error, hard restart the window if it's the only presentation in the playlist.
                    this.shouldHardRestart = true;
                }
                // Flag the current presentation as having errored.
                this.currentWindowError = error;
                this.handleCurrentPresentationComplete();
                return [2 /*return*/];
            });
        }); };
        _this.handleNextPresentationError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var logger, preview, nextPreviewPresentationId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = this.options.logger;
                        // Emit event that preload has failed.
                        this.emitNextWindowErrorEvent('window_preload_error', error);
                        logger.warn("Next presentation had an error, preload the next presentation");
                        preview = this.evalRuleEngine().preview;
                        nextPreviewPresentationId = preview.presentationId;
                        if (!this.shouldPreload(nextPreviewPresentationId)) return [3 /*break*/, 2];
                        // Remove the window before preloading a new one.
                        return [4 /*yield*/, this.removeNextWindow()];
                    case 1:
                        // Remove the window before preloading a new one.
                        _a.sent();
                        // Calling removeNextWindow will set this.nextPresentation to null so we need to
                        // set after but before preloadNextWindow.
                        this.nextPresentation = preview;
                        this.preloadNextWindow();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.removeNextWindow()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.checkPreviewAction = function () { return __awaiter(_this, void 0, void 0, function () {
            var logger, preview;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = this.options.logger;
                        if (!this.ruleEngine) {
                            return [2 /*return*/];
                        }
                        preview = this.ruleEngine.previewNext();
                        if (!this.shouldPreload(preview.presentationId)) return [3 /*break*/, 3];
                        logger.info("Preview check replacing preloaded presentation '".concat(this.nextPresentationId(), "' with new presentation '").concat(preview.presentationId, "'"));
                        return [4 /*yield*/, this.removeNextWindow()];
                    case 1:
                        _a.sent();
                        this.nextPresentation = preview;
                        return [4 /*yield*/, this.preloadNextWindow()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (preview.shouldInterrupt) {
                            logger.info("Interrupting current presentation with '".concat(preview.presentationId, "'"));
                            this.registerInterrupt();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.ruleEngine = options.ruleEngine;
        _this.state = options.state;
        _this.bounds = options.bounds;
        _this.themeOverride = options.themeOverride;
        _this.forceMute = options.forceMute || false;
        return _this;
    }
    PlaylistWindowManager.prototype.currentPresentationId = function () {
        return this.currentPresentation
            ? this.currentPresentation.presentationId
            : null;
    };
    PlaylistWindowManager.prototype.nextPresentationId = function () {
        return this.nextPresentation ? this.nextPresentation.presentationId : null;
    };
    PlaylistWindowManager.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, next, preview, nextPresentationId, nextPreviewPresentationId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.renderer) {
                            throw new Error('Attempted to load playlist window manager with missing renderer');
                        }
                        _a = this.evalRuleEngine(), next = _a.next, preview = _a.preview;
                        nextPresentationId = next.presentationId;
                        nextPreviewPresentationId = preview.presentationId;
                        // Resolve immediately if there if there is no presentation to play next.
                        if (!nextPresentationId) {
                            return [2 /*return*/];
                        }
                        // We need to set this.currentPresentation before calling shouldPreload in order
                        // to avoid preloading the next presentation id if it's the same as the current.
                        this.currentPresentation = next;
                        if (!this.shouldPreload(nextPreviewPresentationId)) return [3 /*break*/, 1];
                        this.nextPresentation = preview;
                        this.preloadNextWindow();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.removeNextWindow()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: 
                    // Load and wait for current window before playing.
                    return [4 /*yield*/, this.loadCurrentWindow()];
                    case 4:
                        // Load and wait for current window before playing.
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.isEmpty = function () {
        if (!this.ruleEngine)
            return true;
        var preview = this.ruleEngine.previewNext();
        return !preview.presentationId;
    };
    PlaylistWindowManager.prototype.play = function () {
        this.restartCurrentWindowOnEnd = false;
        this.playCurrentWindow();
        this.startPreviewCheck();
    };
    PlaylistWindowManager.prototype.isPlaying = function () {
        if (!this.currentWindow) {
            return false;
        }
        return this.currentWindow.isPlaying();
    };
    PlaylistWindowManager.prototype.pause = function () {
        // Pausing a playlist means restarting the current window when it completes
        // instead of moving on to the next one.
        this.restartCurrentWindowOnEnd = true;
        this.pauseCurrentWindow();
        this.stopInterruptCheck();
    };
    PlaylistWindowManager.prototype.resume = function () {
        // Resuming a playlist will switch to the next window when the current window
        // completes. We don't want to fire 'play' because that could restart the window's
        // on complete timer.
        this.restartCurrentWindowOnEnd = false;
        this.resumeCurrentWindow();
        this.startPreviewCheck();
    };
    PlaylistWindowManager.prototype.blur = function () {
        // Use this method to stop creating windows that are focused. There is no renderer API for
        // blurring a window because Electron doesn't have a blur() method on BrowserWindows. If focus
        // should be switched to another PlaylistWindowManager call blur() and then show(true) on the other.
        this.isFocused = false;
    };
    PlaylistWindowManager.prototype.isPaused = function () {
        return this.restartCurrentWindowOnEnd;
    };
    PlaylistWindowManager.prototype.getRenderer = function () {
        return this.renderer;
    };
    PlaylistWindowManager.prototype.setRenderer = function (renderer) {
        this.renderer = renderer;
    };
    PlaylistWindowManager.prototype.getRuleEngine = function () {
        return this.ruleEngine;
    };
    PlaylistWindowManager.prototype.setRuleEngine = function (ruleEngine) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, next, preview, nextPresentationId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.ruleEngine = ruleEngine;
                        _a = this.evalRuleEngine(false), next = _a.next, preview = _a.preview;
                        nextPresentationId = next.presentationId;
                        // If the window manager doesn't have a renderer, update the current and next
                        // presentations but don't load any windows. This handles the case where the
                        // window manager is created with an empty playlist and then has a non-empty
                        // playlist is published to it.
                        if (!this.renderer) {
                            this.currentPresentation = next;
                            this.nextPresentation = preview;
                            return [2 /*return*/];
                        }
                        if (!!nextPresentationId) return [3 /*break*/, 3];
                        this.currentPresentation = null;
                        return [4 /*yield*/, this.removeCurrentWindow()];
                    case 1:
                        _b.sent();
                        this.nextPresentation = null;
                        return [4 /*yield*/, this.removeNextWindow()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                    case 3:
                        // We've already evalulated the rule engine to get the new current presentation and the
                        // new next presentation. The current next presentation is replaced with the new current
                        // presentation. Since we've already evaluated the new next presentation above, we need to
                        // prevent evaling the rule engine again when new current presentation completes by setting
                        // this.overrideNextPresentationId. This fixes an issue where the second presentation in the
                        // playlists is skipped after reinitializing.
                        this.overrideNextPresentation = preview;
                        // Assume the next window is no longer correct when swapping the rule engine.
                        return [4 /*yield*/, this.removeNextWindow()];
                    case 4:
                        // Assume the next window is no longer correct when swapping the rule engine.
                        _b.sent();
                        // Load the new current presentation with the new rule engine.
                        this.nextPresentation = next;
                        return [4 /*yield*/, this.preloadNextWindow()];
                    case 5:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.getState = function () {
        return this.state;
    };
    PlaylistWindowManager.prototype.setState = function (state) {
        this.state = state;
    };
    // For setting dynamic tags data from workers and reevaluate rules for playlists
    // input: newRulesDataStoreObj: {'workers': {'ai': {'percentMales': 30}}}
    PlaylistWindowManager.prototype.reinitializeRuleEngineState = function (newRulesDataStoreObj) {
        var _this = this;
        var logger = this.options.logger;
        logger.debug('Dynamic Rule engine state change event received!');
        if (this.ruleEngine) {
            logger.debug("OLD Rule Data Store: ".concat(JSON.stringify(this.ruleEngine.state), " \n NEW Rule Data Store: ").concat(JSON.stringify(newRulesDataStoreObj)));
            this.ruleEngine.state.rulesDataStore = newRulesDataStoreObj;
        }
        else {
            logger.warn("No Rule engine found for reinitiazling the state!");
            return;
        }
        // re-evaluate the next presentations depending upon the new rule engine state
        var checkOverridePresentation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.ruleEngine) {
                    this.checkPreviewAction();
                    // calling reinitialize Rule engine state for inner playlist windows (for MZ)
                    if (this.currentWindow) {
                        this.currentWindow.reinitializePresentationWindowRuleEngineState(newRulesDataStoreObj);
                    }
                    if (this.nextWindow) {
                        this.nextWindow.reinitializePresentationWindowRuleEngineState(newRulesDataStoreObj);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        checkOverridePresentation();
    };
    // Replace state and rule engine, and reinitialize the window manager.
    PlaylistWindowManager.prototype.reinitialize = function (state, ruleEngine, shouldInterruptPlayback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(state);
                        return [4 /*yield*/, this.setRuleEngine(ruleEngine)];
                    case 1:
                        _a.sent();
                        if (shouldInterruptPlayback) {
                            this.registerInterrupt();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.registerInterrupt = function () {
        if (!this.isLocked()) {
            this.endCurrentPresentation();
        }
        else {
            this.hasPendingInterrupt = true;
        }
    };
    PlaylistWindowManager.prototype.endCurrentPresentation = function () {
        this.handleCurrentPresentationComplete();
    };
    PlaylistWindowManager.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopInterruptCheck();
                        if (this.currentPresentationCompleteTimeout) {
                            clearTimeout(this.currentPresentationCompleteTimeout);
                        }
                        return [4 /*yield*/, Promise.all([this.removeCurrentWindow(), this.removeNextWindow()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.updateBounds = function (bounds) {
        this.bounds = bounds;
        if (this.currentWindow) {
            this.currentWindow.updateBounds(this.bounds);
        }
        if (this.nextWindow) {
            this.nextWindow.updateBounds(this.bounds);
        }
    };
    PlaylistWindowManager.prototype.getBounds = function () {
        return this.bounds;
    };
    PlaylistWindowManager.prototype.setThemeOverride = function (theme) {
        this.themeOverride = theme;
        var currentPresentationId = this.currentPresentationId();
        var nextPresentationId = this.nextPresentationId();
        if (this.currentWindow && currentPresentationId) {
            this.currentWindow.setTheme(this.getTheme(currentPresentationId));
        }
        if (this.nextWindow && nextPresentationId) {
            this.nextWindow.setTheme(this.getTheme(nextPresentationId));
        }
    };
    PlaylistWindowManager.prototype.getThemeOverride = function () {
        return this.themeOverride;
    };
    PlaylistWindowManager.prototype.setForceMute = function (forceMute) {
        this.forceMute = forceMute;
        if (this.currentWindow) {
            this.currentWindow.setForceMute(forceMute);
        }
        if (this.nextWindow) {
            this.nextWindow.setForceMute(forceMute);
        }
    };
    PlaylistWindowManager.prototype.getForceMute = function () {
        return this.forceMute;
    };
    PlaylistWindowManager.prototype.reload = function () {
        if (this.currentWindow) {
            this.currentWindow.reload();
        }
        if (this.nextWindow) {
            this.nextWindow.reload();
        }
    };
    PlaylistWindowManager.prototype.show = function (isFocused) {
        if (isFocused === void 0) { isFocused = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.currentWindow) {
                    // Save the focused state so we know if preloaded windows should be
                    // focused when swapped for the current.
                    this.isFocused = isFocused;
                    this.currentWindow.show(isFocused);
                }
                return [2 /*return*/];
            });
        });
    };
    PlaylistWindowManager.prototype.hide = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.currentWindow) {
                    this.currentWindow.hide();
                }
                return [2 /*return*/];
            });
        });
    };
    PlaylistWindowManager.prototype.isReady = function () {
        if (!this.currentWindow) {
            return true;
        }
        return this.currentWindow.isReady();
    };
    PlaylistWindowManager.prototype.isLocked = function () {
        if (!this.currentWindow) {
            return false;
        }
        return this.currentWindow.isLocked();
    };
    PlaylistWindowManager.prototype.runWorkerSubscriptions = function (state) {
        // Persist worker state so new windows can be initialized with it.
        this.workerState = state;
        // Run worker subcriptions on the current window.
        if (this.currentWindow) {
            this.currentWindow.runWorkerSubscriptions(state);
        }
        // Run worker subscriptions on the next window.
        if (this.nextWindow) {
            this.nextWindow.runWorkerSubscriptions(state);
        }
    };
    PlaylistWindowManager.prototype.sendChargeResponse = function (response) {
        // Send charge response to the current window. The window will check if
        // has a matching request id and if so, send the response to the app.
        if (this.currentWindow) {
            this.currentWindow.sendChargeResponse(response);
        }
        // Send charge response to the next window.
        if (this.nextWindow) {
            this.nextWindow.sendChargeResponse(response);
        }
    };
    PlaylistWindowManager.prototype.sendCharge = function (charge) {
        // Send charge to the current window.
        if (this.currentWindow) {
            this.currentWindow.sendCharge(charge);
        }
        // Send charge to the next window.
        if (this.nextWindow) {
            this.nextWindow.sendCharge(charge);
        }
    };
    PlaylistWindowManager.prototype.sendTerminal = function (terminal) {
        // Send terminal to the current window.
        if (this.currentWindow) {
            this.currentWindow.sendTerminal(terminal);
        }
        // Send terminal to the next window.
        if (this.nextWindow) {
            this.nextWindow.sendTerminal(terminal);
        }
    };
    PlaylistWindowManager.prototype.createWindow = function (pr) {
        var _a = this.options, readyTimeoutDurationSeconds = _a.readyTimeoutDurationSeconds, appRendererUrl = _a.appRendererUrl, appRendererOfflineSupport = _a.appRendererOfflineSupport, backgroundColor = _a.backgroundColor, device = _a.device, logger = _a.logger, windowName = _a.windowName, parentWindowId = _a.parentWindowId, isPreview = _a.isPreview;
        if (!this.ruleEngine) {
            throw new Error('Attempted to create window but ruleEngine was not provided');
        }
        if (!this.state) {
            throw new Error('Attempted to create window but state was not provided');
        }
        if (!this.renderer) {
            throw new Error('Attempted to create window but renderer was not provided');
        }
        var presentationId = pr.presentationId;
        if (!presentationId) {
            throw new Error('Attempted to create window but presentationId is null');
        }
        var presentation = this.state.getPresentation(presentationId);
        var applicationVersion = this.state.getApplicationVersion(presentation.applicationDeploymentId);
        var windowId = (0, uuid_1.v4)();
        return new PresentationWindow_1.default({
            windowManager: this,
            renderer: this.renderer,
            logger: logger,
            windowId: windowId,
            windowName: windowName,
            parentWindowId: parentWindowId,
            presentation: presentation,
            applicationVersion: applicationVersion,
            device: device,
            playlistId: pr.playlistId,
            playlistName: this.ruleEngine.state.playlist(pr.playlistId).name,
            rule: pr.rule,
            publishedAt: this.state.getPublishedAt(),
            theme: this.getTheme(presentationId),
            forceMute: this.forceMute,
            readyTimeoutDurationSeconds: readyTimeoutDurationSeconds,
            appRendererUrl: appRendererUrl,
            appRendererOfflineSupport: appRendererOfflineSupport,
            bounds: this.bounds,
            backgroundColor: backgroundColor,
            playlistWindowManagerState: this.state,
            ruleEngineState: this.ruleEngine.state,
            globalRule: this.ruleEngine.globalRule,
            isPreview: isPreview,
            workerState: this.workerState,
            getTerminal: this.options.getTerminal,
        });
    };
    PlaylistWindowManager.prototype.loadCurrentWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logger;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = this.options.logger;
                        if (!this.currentPresentation) {
                            logger.warn("Attempted to load current window but currentPresentation not set");
                            return [2 /*return*/];
                        }
                        this.currentWindow = this.createWindow(this.currentPresentation);
                        this.currentWindow.onComplete(this.handleCurrentPresentationComplete);
                        this.currentWindow.onError(this.handleCurrentPresentationError);
                        this.currentWindow.onEnableInterruptLock(this.handleEnableInterruptLock);
                        this.currentWindow.onDisableInterruptLock(this.handleDisableInterruptLock);
                        this.currentWindow.onAnalyticsEvent(this.handleAnalyticsEvent);
                        this.currentWindow.onChargeRequest(this.handleChargeRequest);
                        return [4 /*yield*/, this.currentWindow.load()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.shouldPreload = function (presentationId) {
        // Don't preload if there is no presentation.
        if (presentationId === null) {
            return false;
        }
        // Don't preload the next presentation if it's already preloaded. When the window manager
        // is first created it will eval the rule engine and set this.nextPresentationId but not
        // this.nextWindow.
        if (presentationId === this.nextPresentationId()) {
            return false;
        }
        // An optimization to avoid preloading the same presentation we are currenly playing.
        // When the current presentation completes we will play it again and then check for
        // a new presentation to preload.
        if (presentationId === this.currentPresentationId()) {
            return false;
        }
        return true;
    };
    PlaylistWindowManager.prototype.preloadNextWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logger;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = this.options.logger;
                        if (!this.nextPresentation) {
                            logger.warn("Attempted to preload next window but nextPresentation not set");
                            return [2 /*return*/];
                        }
                        this.nextWindow = this.createWindow(this.nextPresentation);
                        this.nextWindow.onError(this.handleNextPresentationError);
                        return [4 /*yield*/, this.nextWindow.load()];
                    case 1:
                        _a.sent();
                        // If there is no current window and the next window successfully loaded, show the preloaded window.
                        // NOTE: Apps that use raydiant-kit's onError handler will end up showing an error on screen anyways
                        // because the onError method fires presentation_ready before sending the error. We should fix this
                        // but would require updating raydiant-kit and then all apps.
                        if (!this.currentWindow && !this.nextWindow.didError()) {
                            this.handleCurrentPresentationComplete();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.playCurrentWindow = function () {
        var logger = this.options.logger;
        if (this.currentWindow) {
            this.currentWindow.play();
            this.emitCurrentWindowEvent('window_play');
        }
        else {
            logger.warn("Attempted to play current window but it doesn't exist");
        }
    };
    PlaylistWindowManager.prototype.pauseCurrentWindow = function () {
        var logger = this.options.logger;
        if (this.currentWindow) {
            this.currentWindow.pause();
        }
        else {
            logger.warn("Attempted to pause current window but it doesn't exist");
        }
    };
    PlaylistWindowManager.prototype.resumeCurrentWindow = function () {
        var logger = this.options.logger;
        if (this.currentWindow) {
            this.currentWindow.resume();
        }
        else {
            logger.warn("Attempted to resume current window but it doesn't exist");
        }
    };
    PlaylistWindowManager.prototype.restartCurrentWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logger;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = this.options.logger;
                        if (!this.currentWindow) return [3 /*break*/, 5];
                        if (!this.shouldHardRestart) return [3 /*break*/, 3];
                        logger.info("Restart current window with hard restart");
                        return [4 /*yield*/, this.removeCurrentWindow()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCurrentWindow()];
                    case 2:
                        _a.sent();
                        this.currentWindow.show(this.isFocused);
                        return [3 /*break*/, 4];
                    case 3:
                        logger.info("Restart current window");
                        this.currentWindow.reset();
                        _a.label = 4;
                    case 4:
                        this.playCurrentWindow();
                        return [3 /*break*/, 6];
                    case 5:
                        logger.warn("Attempted to restart current window but it doesn't exist");
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.removeCurrentWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentWindow) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.currentWindow.remove()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentWindow = null;
                        this.currentPresentation = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.removeNextWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.nextWindow) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nextWindow.remove()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.nextWindow = null;
                        this.nextPresentation = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.swapWindows = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nextPreviewPresentationId, preview, result, nextPresentation, shouldPreload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextPreviewPresentationId = null;
                        preview = null;
                        if (this.overrideNextPresentation) {
                            preview = this.overrideNextPresentation;
                            nextPreviewPresentationId = this.overrideNextPresentation.presentationId;
                            this.overrideNextPresentation = null;
                        }
                        else {
                            result = this.evalRuleEngine();
                            preview = result.preview;
                            nextPreviewPresentationId = preview.presentationId;
                        }
                        nextPresentation = this.nextPresentation;
                        // Set this.currentPresentationId before removing the current window to avoid timing issues with previewCheck
                        // triggering during removeCurrentWindow. Current presentation id needs to be set to the next
                        // presentation before calling shouldPreload().
                        this.currentPresentation = this.nextPresentation;
                        shouldPreload = this.shouldPreload(nextPreviewPresentationId);
                        if (shouldPreload) {
                            // Set this.nextPresentationId before removing the current window. This prevents
                            // race conditions with previewCheck when using the window pool, where removeWindow
                            // is async because we unload the window instead of destroying it.
                            this.nextPresentation = preview;
                        }
                        // Clear the pending interrupt whenever we swap the current window for the next one.
                        this.hasPendingInterrupt = false;
                        // Next window is ready, show the next one, hide the current window, and
                        // then remove the current window. Show the next window before hiding the
                        // current to avoid flashes when rendering with BrowserWindows on device.
                        if (this.nextWindow) {
                            this.nextWindow.show(this.isFocused);
                        }
                        if (!this.currentWindow) return [3 /*break*/, 2];
                        this.currentWindow.hide();
                        return [4 /*yield*/, this.removeCurrentWindow()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Swap windows.
                        this.currentWindow = this.nextWindow;
                        if (this.currentWindow) {
                            // Restore this.currentPresentation value since if this.removeCurrentWindow()
                            // was called then this.currentPresentation was set to null.
                            // This fixes an issue where publishing a playlist with single presentation results
                            // in two iFrames created. See CX-2602 for more details.
                            this.currentPresentation = nextPresentation;
                            this.currentWindow.onComplete(this.handleCurrentPresentationComplete);
                            this.currentWindow.onError(this.handleCurrentPresentationError);
                            this.currentWindow.onEnableInterruptLock(this.handleEnableInterruptLock);
                            this.currentWindow.onDisableInterruptLock(this.handleDisableInterruptLock);
                            this.currentWindow.onAnalyticsEvent(this.handleAnalyticsEvent);
                            this.currentWindow.onChargeRequest(this.handleChargeRequest);
                        }
                        // Play new current window.
                        this.playCurrentWindow();
                        // Preload the next presentation if there is one.
                        if (shouldPreload) {
                            this.preloadNextWindow();
                        }
                        else {
                            // Set next window to null to reset preload state. We don't want to
                            // remove the next window because it's the new current window.
                            this.nextWindow = null;
                            this.nextPresentation = null;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PlaylistWindowManager.prototype.evalRuleEngine = function (warnIfPreloadMismatch) {
        if (warnIfPreloadMismatch === void 0) { warnIfPreloadMismatch = true; }
        var logger = this.options.logger;
        if (!this.ruleEngine) {
            throw new Error('Attempted to eval rule engine but ruleEngine not provided');
        }
        var next = this.ruleEngine.next();
        var preview = this.ruleEngine.previewNext();
        var nextPresentationId = next.presentationId;
        if (this.nextPresentationId() !== null &&
            nextPresentationId !== this.nextPresentationId() &&
            warnIfPreloadMismatch) {
            // TODO: Handle the case when the next presentation isn't the preloaded window.
            // This can happen when we support dynamic rule engine state.
            logger.warn("The next presentation id '".concat(nextPresentationId, "' doesnt match preloaded presentation id '").concat(this.nextPresentationId(), "'"));
        }
        return { next: next, preview: preview };
    };
    PlaylistWindowManager.prototype.startPreviewCheck = function () {
        var _this = this;
        var checkPreview = function () { return __awaiter(_this, void 0, void 0, function () {
            var now, nextMinute, timeUntilNextMinute;
            return __generator(this, function (_a) {
                if (this.ruleEngine) {
                    this.checkPreviewAction();
                }
                now = new Date();
                nextMinute = new Date();
                nextMinute.setMilliseconds(0);
                nextMinute.setSeconds(1);
                nextMinute.setMinutes(now.getMinutes() + 1);
                timeUntilNextMinute = +nextMinute - +now;
                this.interruptCheckTimeout = setTimeout(checkPreview, timeUntilNextMinute);
                return [2 /*return*/];
            });
        }); };
        checkPreview();
    };
    PlaylistWindowManager.prototype.stopInterruptCheck = function () {
        if (this.interruptCheckTimeout) {
            clearTimeout(this.interruptCheckTimeout);
        }
    };
    PlaylistWindowManager.prototype.getTheme = function (presentationId) {
        if (!this.state)
            return;
        var theme;
        var presentation = this.state.getPresentation(presentationId);
        if (this.themeOverride) {
            theme = this.themeOverride;
        }
        else if (presentation.themeId && this.state) {
            theme = this.state.getTheme(presentation.themeId);
        }
        return theme;
    };
    PlaylistWindowManager.prototype.emitWindowEvent = function (label, event, window, data) {
        var logger = this.options.logger;
        if (window) {
            this.emit(event, __assign(__assign({}, window.metadata()), { data: data }));
        }
        else {
            logger.warn("Attempted to emit ".concat(label, " window event but window not set"));
        }
    };
    PlaylistWindowManager.prototype.emitCurrentWindowEvent = function (event, data) {
        return this.emitWindowEvent('current', event, this.currentWindow, data);
    };
    PlaylistWindowManager.prototype.emitNextWindowEvent = function (event, data) {
        return this.emitWindowEvent('next', event, this.nextWindow, data);
    };
    PlaylistWindowManager.prototype.emitCurrentWindowErrorEvent = function (event, error) {
        return this.emitCurrentWindowEvent(event, {
            errorMessage: this.getErrorMessage(error),
        });
    };
    PlaylistWindowManager.prototype.emitNextWindowErrorEvent = function (event, error) {
        return this.emitNextWindowEvent(event, {
            errorMessage: this.getErrorMessage(error),
        });
    };
    PlaylistWindowManager.prototype.getErrorMessage = function (error) {
        if (typeof error === 'string')
            return error;
        if (error && typeof error === 'object' && error.message)
            return error.message;
        return '';
    };
    return PlaylistWindowManager;
}(eventemitter3_1.default));
exports.default = PlaylistWindowManager;
